var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
const defaultReducerState = {
  workspaceId: "",
  name: "",
  FromName: "",
  FromVersion: "",
  dataSourceItem: getDefaultAsyncWrapperObj(),
  createDataSource: getDefaultAsyncWrapperObj(),
  updateDataSource: getDefaultAsyncWrapperObj(),
  parameterList: [],
  streamList: []
};
const createDataSourceOverridePrefix = "createDataSourceOverride";
const createDataSourceOverrideActionTypes = {
  LOAD: `${createDataSourceOverridePrefix}/LOAD`,
  LOADING: `${createDataSourceOverridePrefix}/LOADING`,
  LOADED: `${createDataSourceOverridePrefix}/LOADED`
};
const updateDataSourceOverridePrefix = "updateDataSourceOverride";
const updateDataSourceOverrideActionTypes = {
  LOAD: `${updateDataSourceOverridePrefix}/LOAD`,
  LOADING: `${updateDataSourceOverridePrefix}/LOADING`,
  LOADED: `${updateDataSourceOverridePrefix}/LOADED`
};
const CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION = `${updateDataSourceOverridePrefix}/CLEAR_REQUEST`;
const createDataSourceOverrideConstants = {
  SetCreateDataSource: `${createDataSourceOverridePrefix}/SetCreateDataSource`
};
const setCreateDataSource = (state, actionResult) => {
  return __spreadProps(__spreadValues({}, state), {
    createDataSource: actionResult.payload
  });
};
function SetCreateDataSource(createDataSource2) {
  return {
    type: createDataSourceOverrideConstants.SetCreateDataSource,
    payload: createDataSource2.createDataSource
  };
}
const createDataSource = (workspaceId, dataSourceConfiguration) => {
  return {
    type: createDataSourceOverrideActionTypes.LOAD,
    payload: dataSourceConfiguration
  };
};
const creatingDataSource = () => {
  return {
    type: createDataSourceOverrideActionTypes.LOADING,
    payload: {}
  };
};
const createdDataSource = (createDataSource2) => {
  return {
    type: createDataSourceOverrideActionTypes.LOADED,
    payload: {
      createDataSource: createDataSource2
    }
  };
};
const updateDataSource = (workspaceId, dataSourceConfiguration, baseOnVersion) => {
  return {
    type: updateDataSourceOverrideActionTypes.LOAD,
    payload: dataSourceConfiguration
  };
};
const updatingDataSource = () => {
  return {
    type: updateDataSourceOverrideActionTypes.LOADING,
    payload: {}
  };
};
const updatedDataSource = (updateDataSource2) => {
  return {
    type: updateDataSourceOverrideActionTypes.LOADED,
    payload: {
      updateDataSource: updateDataSource2
    }
  };
};
const clearDataSourceOverrideUpdateRequest = () => {
  return {
    type: CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION
  };
};
const dataSourceCreateReducer = (state = defaultReducerState, action) => {
  switch (action.type) {
    case createDataSourceOverrideConstants.SetCreateDataSource:
      return setCreateDataSource(state, action);
    case createDataSourceOverrideActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        createDataSource: __spreadProps(__spreadValues({}, state.createDataSource), {
          status: AsyncRequestStatus.Pending
        })
      });
    case updateDataSourceOverrideActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        updateDataSource: __spreadProps(__spreadValues({}, state.updateDataSource), {
          status: AsyncRequestStatus.Pending
        })
      });
    case createDataSourceOverrideActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        createDataSource: __spreadProps(__spreadValues({}, state.createDataSource), {
          data: action.payload.createDataSource.data,
          status: !!action.payload.createDataSource.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          error: action.payload.createDataSource.error
        })
      });
    case updateDataSourceOverrideActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        updateDataSource: __spreadProps(__spreadValues({}, state.updateDataSource), {
          data: action.payload.updateDataSource.data,
          status: !!action.payload.updateDataSource.error ? AsyncRequestStatus.Failed : AsyncRequestStatus.Completed,
          error: action.payload.updateDataSource.error
        })
      });
    case CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION:
      return __spreadProps(__spreadValues({}, state), {
        updateDataSource: getDefaultAsyncWrapperObj()
      });
    default:
      return state;
  }
};
export {
  CLEAR_DATASOURCE_OVERRIDE_UPDATE_ACTION,
  SetCreateDataSource,
  clearDataSourceOverrideUpdateRequest,
  createDataSource,
  createDataSourceOverrideActionTypes,
  createDataSourceOverrideConstants,
  createdDataSource,
  creatingDataSource,
  dataSourceCreateReducer,
  dataSourceCreateReducer as default,
  defaultReducerState,
  updateDataSource,
  updateDataSourceOverrideActionTypes,
  updatedDataSource,
  updatingDataSource
};
//# sourceMappingURL=DataSourceCreateContainer.ducks.js.map
